import React, { useState, useEffect} from "react";
import { Card, Row, Col, Divider, Menu, Spin, Empty } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Constants

// Components
import { FilterDays } from "../../../../components/TableList";

// Redux Actions


import { REDUX as REDUX_UTIL } from "../../../../services/util";

import { compData, empData } from "../../handler"
import { dashboardHDLR } from "../../../../handlers"

// Style
import "../../index.css";


const { reduxStoreWrapper } = REDUX_UTIL;

const TopCompanies = (props) =>{
  const { items, loading } = props;
  // const dispatch = useDispatch()

  //   const payrolls = useSelector(reduxStoreWrapper("dashboard.daily.payrolls"));
  const summaries = useSelector(reduxStoreWrapper("dashboard.daily.summaries"));
  const companies = useSelector(reduxStoreWrapper("company.byID"));
  const employees = useSelector(reduxStoreWrapper("dashboard.daily.employeesByDays"));

  const [current, setCurrent] = useState('company');
  const [selectedDays, setSelectedDays] = useState(30); 
  const [dailyComp, setDailyComp] = useState([]);
  const [dailyEmp, setDailyEmp] = useState([]);
  const [load, setLoad] = useState(false);
  const [load2, setLoad2] = useState(false);

  useEffect(() => {
    if (!load && summaries.length > 0) {
      setDailyComp(summaries);
      setLoad(true);
    }
  }, [load, summaries]);

  useEffect(() => {
    if (!load2 && employees?.[90]?.length > 0) {
      setDailyEmp(employees[90]);
      setLoad2(true);
    }
  }, [load2, employees[90]]);
  
    const sum = dailyComp.filter(s => s.total_pr_reqAmount > 0)
    const resultComp = Object.values(compData(sum, companies)).map(c => ({...c, key: c.coid}));
    const resultEmp = Object.values(empData(dailyEmp)).map(e => ({...e, key: e.uid}));

    const MenuList = [
        {
            label: 'Company',
            key: 'company',
        }, 
        {
            label: 'Employee',
            key: 'employee',
        },
    ] 

    const onClick = (e) => {
        setCurrent(e.key);
    };

    const handleOptionDays = (value) => {
        setSelectedDays(value);
        const newDataComp = dashboardHDLR.filterByDays(summaries, value)
        setDailyComp(newDataComp)
        setDailyEmp(employees[value])
      };

    const sortedCompanies = resultComp.sort((a, b) => b.applied - a.applied).slice(0, 5);
    const sortedEmployees = resultEmp.sort((a, b) => b.applied - a.applied).slice(0, 5);

    const renderCompanyContent = () => (
        <Col style={{ margin: "14px 0px" }}>
          {sortedCompanies.map((company, index) => {
            const rate = (((company.applied / company.total_employee) * 100) || 0).toFixed(1) 
            const applicationRate = isFinite(rate) ? rate : 0

            return (
              <React.Fragment key={index}>
                <Row id={index === 0 ? "top-one" : undefined} style={index === 1 ? { marginTop: "13px" } : undefined}>
                  <Col span={3} className={index === 0 ? "center" : "gray-text center"}>{index + 1}</Col>
                  <Col span={17} className={index === 0 ? undefined : "dark-gray-text"}>
                    <Row className="space-text">{company.companyName}</Row>
                    <Row>Active employees: {company.total_employee_activate} ({applicationRate}% application rate)</Row>
                  </Col>
                  <Col span={4}>
                    <Row className={index === 0 ? "space-text" : "dark-gray-text space-text"}>Applied</Row>
                    <Row>{company.applied}</Row>
                  </Col>
                </Row>
                {index > 0 && index < sortedCompanies.length - 1 && <Divider />}
              </React.Fragment>
            );
          })}
        </Col>
      );
      

    const renderEmployeeContent = () => (
        <Col style={{ margin: "14px 0px" }} >
            {sortedEmployees.map((emp, index) => (
                <React.Fragment key={index}>
                    <Row id={index === 0 ? "top-one" : undefined} style={index === 1 ? { marginTop: "13px" } : undefined}>
                        <Col span={3} className={index === 0 ? "center" : "gray-text center"}>{index + 1}</Col>
                        <Col span={17} className={index === 0 ? undefined : "dark-gray-text"}>
                            <Row className="space-text">{emp.employeeName}</Row>
                            <Row>{emp.companyName}</Row>
                        </Col>
                        <Col span={4}>
                            <Row className={index === 0 ? "space-text" : "dark-gray-text space-text"}>Applied</Row>
                            <Row>{emp.applied}</Row>
                        </Col>
                    </Row>
                    {index > 0 && index < sortedEmployees.length - 1 && <Divider />}
                </React.Fragment>
            ))}
        </Col>
    );

    return (
        <Card className="row-space card-shadow height-card">
            <div className="header-card">
                <span className="title-card">Top Applied Companies</span>
                <FilterDays
                    defaultValue={selectedDays}
                    items={items}
                    handleChange={handleOptionDays}
                />
            </div>

            <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={MenuList} />
          
            {loading || Object.values(companies).length === 0 ? (
                <Spin style={{width: "95%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center"}} />
            ) : (
              current === 'company' ? (sum.length ? renderCompanyContent() : <div style={{marginTop: "50px"}}><Empty description={false} /></div>) : (dailyEmp.length ? renderEmployeeContent() :  <div style={{marginTop: "50px"}}><Empty description={false} /></div>)
            )}
        </Card>
    );
};

export default TopCompanies;